import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// 驱动界面里右键常用于测试按键，屏蔽浏览器自带菜单；输入框保留复制粘贴菜单
window.addEventListener('contextmenu', (event) => {
  const target = event.target;
  if (target instanceof Element && target.closest('input, textarea, [contenteditable="true"]')) {
    return;
  }
  event.preventDefault();
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
